


















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatAttachmentFile',
  data() {
    return {
      isImage: false,
      imageSrc: '',
      fileName: this.doc.name,
      fileSize: this.doc.size,
      formattedFileSize: '',
      fileType: this.doc.type,
    };
  },
  props: {
    doc: {
      type: File as PropType<File>,
    },
  },
  methods: {
    onClickDelete() {
      this.$emit('delete');
    },
    formatFileSize() {
      if (!this.fileSize) {
        this.formattedFileSize = '0 Bytes';
        return;
      }
      const k = 1000;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(this.fileSize) / Math.log(k));
      if (!sizes[i]) {
        this.formattedFileSize = `${this.fileSize}`;
        return;
      }
      this.formattedFileSize = `${this.fileSize / k ** i} ${sizes[i]}`;
    },
    checkIfImage() {
      const regex = RegExp(/image|png|jpg|jpeg/);
      this.isImage = regex.test(this.fileType);
      if (!this.isImage) return;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(this.doc);
    },
  },
  mounted() {
    this.checkIfImage();
    this.formatFileSize();
  },
});
